var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-panel-v"},[_c('DataGrid',{attrs:{"size":"mini","resizable":"","data":_vm.data}},_vm._l((_vm.columns),function(column,index){return _c('DataGridColumn',{key:index,attrs:{"field":column.field,"title":column.title,"width":column.width,"align":column.align || 'left'}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }